import type { Document } from '@contentful/rich-text-types';
import type Maybe from 'graphql/tsutils/Maybe';

import type { PromoCodeConfigFragment } from '../__generated__/contentfulTypes';

export const getPromoCodeSubstMap = (
  promoCodes?: Array<Maybe<{ __typename?: 'EntWebsitePromoCodeConfig' } & PromoCodeConfigFragment>>,
  promoCodeQueryParamValue = 'default'
): Record<string, string> => {
  let searchKey = String(promoCodeQueryParamValue);
  if (searchKey === '') searchKey = 'default';

  let promoCode = promoCodes?.find((item) => item?.promoCodeUrlQueryValue === searchKey);

  // If no promoCode found - try to get default one
  if (promoCode == null) promoCode = promoCodes?.find((item) => item?.promoCodeUrlQueryValue === 'default');

  return (
    (promoCode?.config as Array<{ key: string; value: string }>)?.reduce?.(
      (currMap, currItem) => ({
        ...currMap,
        [currItem?.key]: currItem?.value,
      }),
      {}
    ) ?? {}
  );
};

export const runSubstituitonsForString = (
  str: string | null | undefined,
  substMap: Record<string, string>
): string | null => {
  if (str == null) return null;

  let res = String(str);

  for (const key in substMap) {
    if (Object.hasOwn(substMap, key)) {
      res = res.replace(new RegExp(`{{${key}}}`, 'g'), substMap[key]);
    }
  }

  return res;
};

export const runSubstituitonsForRichText = (
  doc: Document | undefined | null,
  substMap: Record<string, string>
): Document | null => {
  if (doc == null) return null;

  const newContent = doc?.content?.map((item) => ({
    ...item,
    content: item?.content?.map((contentItem) => {
      if (contentItem?.nodeType !== 'text') return contentItem;

      let newVal = String(contentItem?.value);

      for (const key in substMap) {
        if (Object.hasOwn(substMap, key)) newVal = newVal.replace(new RegExp(`{{${key}}}`, 'g'), substMap[key]);
      }

      return { ...contentItem, value: newVal };
    }),
  }));

  return { ...doc, content: newContent };
};
